import React from 'react';
import { LogoutButton } from './LogoutButton';

export function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center">
            <img 
              src="/assets/logo/icone_logo_ft.png"
              alt="FT Viagens"
              className="h-full w-full object-contain"
            />
          </div>
          <h1 className="text-lg font-semibold text-gray-900 hidden md:block">
            Alertas de Passagens
          </h1>
        </div>
        <div className="md:hidden">
          <h1 className="text-lg font-semibold text-gray-900">
            Alertas de Passagens
          </h1>
        </div>
        <LogoutButton />
      </div>
    </header>
  );
}